// eslint-disable-next-line import/prefer-default-export
export const CMSPriceHikeGoals = [
  'YOTUH',
  'KSCGY',
  'PESHE',
  'GWDPV',
  'QOIVT',
  'TMUVD',
  'NQECF',
  'LEARNCP'
];
